import React, { useEffect, useState } from 'react';
import { Popup } from 'antd-mobile';

const defaultActions = [
  { index: 0, text: '全部交易', sort_type: '' },
  { index: 1, text: '官方严选', sort_type: 'gfyx' },
  { index: 2, text: '自由交易', sort_type: 'zyjy' },
  { index: 3, text: '价格升序', sort_type: 'asc' },
  { index: 4, text: '价格降序', sort_type: 'desc' },
];

const devices = [
  { index: 0, text: '双端', game_device_type: '0' },
  { index: 1, text: '安卓', game_device_type: '1' },
  { index: 2, text: '苹果', game_device_type: '2' },
];

export default function SearchAlert({
  visible,
  onClose,
  onConfirm,
  actions = defaultActions,
  value,
}) {
  const [sortIndex, setSortIndex] = useState(value?.index ?? 0);
  const [gameDeviceType, setGameDeviceType] = useState(value?.game_device_type ?? '0');

  useEffect(() => {
    if (visible) {
      setSortIndex(value?.index ?? 0);
      setGameDeviceType(value?.game_device_type ?? '0');
    }
  }, [visible, value]);

  const handleReset = () => {
    setSortIndex(0);
    setGameDeviceType('0');
  };

  const handleConfirm = () => {
    const currentAction = actions[sortIndex] || actions[0] || defaultActions[0];
    onConfirm?.({
      ...currentAction,
      index: sortIndex,
      text: currentAction.text,
      game_device_type: gameDeviceType,
      sort_type: currentAction.sort_type,
    });
    onClose?.();
  };

  return (
    <Popup
      visible={visible}
      onMaskClick={onClose}
      bodyStyle={{
        borderTopLeftRadius: '16px',
        borderTopRightRadius: '16px',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      <div className="tlf-container">
        <div className="tlf-section-title">排序方式</div>
        <div className="tlf-options">
          {actions.map((item, index) => (
            <div
              key={item.index ?? index}
              className={'tlf-option' + (sortIndex === index ? ' active' : '')}
              onClick={() => setSortIndex(index)}
            >
              {item.text}
            </div>
          ))}
        </div>

        <div className="tlf-section-title">设备</div>
        <div className="tlf-options">
          {devices.map(item => (
            <div
              key={item.index}
              className={'tlf-option' + (gameDeviceType === item.game_device_type ? ' active' : '')}
              onClick={() => setGameDeviceType(item.game_device_type)}
            >
              {item.text}
            </div>
          ))}
        </div>

        <div className="tlf-operate">
          <button className="tlf-btn tlf-btn-reset" onClick={handleReset}>重置</button>
          <button className="tlf-btn tlf-btn-confirm" onClick={handleConfirm}>确定</button>
        </div>
      </div>
    </Popup>
  );
}
